module.exports = __webpack_public_path__ + "img/about_banner_btn.acbc9bfa.png";